const e=async(e,t)=>{let{data:n}=await e.get(`/orgs/search`,{params:t});return n};export{e as searchOrgs};
//# sourceMappingURL=search-orgs.mjs.map